import {useEffect, useState} from "react";
import getOptions from "../../tools/api/global/getOptions";

const useOptions = ({key,preventRequest}) => {
    const [optionLoading,setLoading]=useState(!preventRequest);
    const [options,setOptions]=useState(null);
    useEffect(async () => {
        async function fetchOptions() {
            setLoading(true)
            const response=await getOptions();
            setLoading(false);
            if(!response.hasError){
                if(key){
                    response.data.forEach((item,index)=>{
                        if(item.key===key){

                            if(item.value){
                                setOptions(JSON.parse(item.value))
                            }
                        }
                    })
                }else {
                    setOptions(response.data)
                }
            }else {

            }
        }
        if(!preventRequest){
            await fetchOptions();
        }

    },[]);
    return {optionLoading,options}
}
export default useOptions;